import React, { useContext, useEffect, useState } from "react";
import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import moment from "moment";
import pl from "date-fns/locale/pl";
import DatePicker, { registerLocale } from "react-datepicker";
import { BasicContext } from "../../App";
import { BackOfficeContext } from "../admin/BackOffice";
import { daysLater } from "../../commonData";
import { postMethod } from "../../requests";
import GoBackBtn from "../../components/buttons/GoBackBtn";
import ClassCard from "../../components/classes/ClassCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faWarning } from "@fortawesome/free-solid-svg-icons";
import SelectStudentDropdown from "../../components/dropdowns/SelectStudentDropdown";
registerLocale("pl", pl);

const CreatingReservation = () => {
    const { t } = useTranslation();
    const { checkServerData, changeView, setAlerts, showView } = useContext(BasicContext);
    const classT = showView.params.class;
    const [loading, setLoading] = useState(false);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const { settings } = useContext(BackOfficeContext);
    const reservDuration = settings.filter((e) => e.setting_code === "RESERVATION_DURATION")[0].setting_value_int;
    const [reservAlert, setReservAlert] = useState(null);
    const initData = {
        user_id: null,
        ur_end_date: daysLater(new Date(), reservDuration) > new Date(classT.class_start_time) ? new Date(classT.class_start_time) : daysLater(new Date(), reservDuration),
    };
    const [reservation, setReservation] = useState(initData);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (!reservation.user_id) {
            $(`#studentsDropdown`).addClass("is-invalid");
            errors.push(t("error.noChosenStudent"));
        } else if (classT.instructor_id === reservation.user_id) {
            $(`#studentsDropdown`).addClass("is-invalid");
            errors.push(t("error.chosenStudentCannotBeInstrutorOfThisClass"));
        }

        if (!reservation.ur_end_date) {
            $(`#reservationEndDate`).addClass("is-invalid");
            errors.push(t("error.noSelectedReservationEndDate"));
        } else if (moment(reservation.ur_end_date).format("YYYY-MM-DD") > moment(classT.class_start_time).format("YYYY-MM-DD")) {
            $(`#reservationEndDate`).addClass("is-invalid");
            errors.push(t("error.reservationEndDateCannotBeLaterThanClassStartTime"));
        } else if (moment(reservation.ur_end_date).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")) {
            $(`#reservationEndDate`).addClass("is-invalid");
            errors.push(t("error.endDateCannotBeEarlierThanToday"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.creatingNewReservation") }]);
            setBlockForm(true);
            createReservation();
        }
    };

    const createReservation = async () => {
        const res = await postMethod("/create-reservation", { reservation: reservation, classT: classT });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "createdReservation" }]);
            changeView({ nav: "schedule", sub: "main", params: { moduleName: "ADMIN_APP" } });
        }
        setBlockForm(false);
    };

    const checkReserv = async () => {
        const res = await postMethod("/check-reservation", { reservation: reservation, classT: classT });
        if (checkServerData(res)) {
            if (res.data.userHasReserv) setReservAlert("studentHasAlreadyValidReservation");
            else {
                setReservAlert(null);
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (reservation.user_id) checkReserv(reservation.user_id);

        // eslint-disable-next-line
    }, [reservation.user_id]);

    return (
        <div id="createSchedule">
            <GoBackBtn />
            <Container fluid="lg">
                <Row>
                    <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                        <h1 className="h5 d-inline-block m-0 pt-2">{t("reservations.creatingNewReservation")}</h1>
                    </Col>
                    <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                        <Row>
                            <Col xs={12} lg={6} xxl={5}>
                                <ClassCard c={classT} />
                            </Col>
                        </Row>
                    </Col>
                    {classT.free_slots < 1 ? (
                        <Alert variant="info">
                            {t("info.classHasNoFreeSlots")} {t("error.cannotMakeReservation")}
                        </Alert>
                    ) : loading ? (
                        <Col xs={12} className="my-5 text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    ) : (
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <Form onSubmit={checkValidation} autoComplete="off">
                                <Row>
                                    <Col xs={12}>
                                        <SelectStudentDropdown
                                            onChange={(v) => {
                                                setReservation({ ...reservation, user_id: v });
                                                setFormChanged(true);
                                                $("#studentsDropdown").removeClass("is-invalid");
                                            }}
                                            value={reservation.user_id}
                                            req
                                            id="studentsDropdown"
                                            disabled={blockForm}
                                        />
                                        {reservAlert && (
                                            <Alert variant="warning" className="alert-small">
                                                <FontAwesomeIcon icon={faWarning} className="me-2" />
                                                {t("error.studentHasAlreadyValidReservation")} {t("chooseAnotherStudent")}
                                            </Alert>
                                        )}
                                    </Col>

                                    <Col xs={12} lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                {t("reservations.reservationEndDate")} <span className="req">*</span>
                                            </Form.Label>
                                            <DatePicker
                                                autoComplete="off"
                                                selected={reservation.ur_end_date}
                                                onChange={(date) => {
                                                    setReservation({ ...reservation, ur_end_date: date });
                                                    $("#reservationEndDate").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                                showIcon
                                                locale="pl"
                                                dateFormat="yyyy-MM-dd"
                                                icon={<FontAwesomeIcon icon={faCalendar} />}
                                                placeholderText={t("choose")}
                                                id="reservationEndDate"
                                                disabled={blockForm}
                                                minDate={moment().format("YYYY-MM-DD")}
                                                maxDate={moment(classT.class_start_time).format("YYYY-MM-DD")}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="sticky-bottom bg-light-primary" style={{ zIndex: 1 }}>
                                    <Col xs={12} className="my-4">
                                        <Button variant="primary" type="submit" disabled={blockForm || !formChanged}>
                                            {t("create")}
                                        </Button>

                                        <Button
                                            variant="outline-secondary"
                                            className="float-end"
                                            onClick={() => changeView({ nav: "schedule", sub: "main", params: { moduleName: "ADMIN_APP" } })}
                                        >
                                            {t("cancel")}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    )}
                </Row>
            </Container>
        </div>
    );
};

export default CreatingReservation;
